import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { selector: String };
  connect() {}

  update(event) {
    if (this.selectorButton.checked) {
      return;
    }
    Array.from(this.checkboxes).forEach((checkbox) => {
      checkbox.checked = false;
    });
  }

  get selectorButton() {
    return this.element.querySelector('input[type="radio"]');
  }

  get checkboxes() {
    return this.element.querySelectorAll('input[type="checkbox"]');
  }
}
